// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"19b764e8","134":"769d2c3f","385":"33d933e5","506":"8580a614","576":"6eacd40e","642":"c60b59ed","658":"5f6047de","744":"316f6259"}[chunkId] + ".chunk.js";
};